import {useMemo} from "react"
import {useAppRouteContext} from "@irati/utils/history"

export interface WithPerkOrReward {
  isPerks?: boolean
  isRewards?: boolean
  isWallet?: boolean
  isRecognition?: boolean
}

interface Props {
  hasWalletDealCard?: boolean
}

export const usePerkOrReward = ({hasWalletDealCard}: Props = {}): WithPerkOrReward => {
  const {apps, appPath} = useAppRouteContext()
  const {ADMIN, FLEXIREWARDS, PERKS, SEARCH, WALLET, RECOGNITION} = apps
  const isNonWalletAdminDeal = appPath === ADMIN && hasWalletDealCard
  const isRewards = appPath === SEARCH && window.location.pathname === `${SEARCH}/rewards`

  return useMemo(
    () => ({
      isRecognition: appPath === RECOGNITION,
      isPerks: appPath === PERKS || isNonWalletAdminDeal,
      isRewards: appPath === FLEXIREWARDS || isRewards,
      isWallet: appPath === WALLET || appPath === ADMIN
    }),
    [ADMIN, FLEXIREWARDS, PERKS, RECOGNITION, WALLET, appPath, isNonWalletAdminDeal, isRewards]
  )
}
